import { safeAnalyticsPath } from '../services/analytics-privacy';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AnalyticsService } from '../services/analytics.service';
import { AnalyticsEvents } from '../models/analytics-events';
import { environment } from '../../environments/environment';

export function normalizeAnalyticsEndpoint(url: string): string {
    return safeAnalyticsPath(url);
}

/**
 * HTTP interceptor that tracks API errors for PostHog analytics.
 */
export const analyticsInterceptor: HttpInterceptorFn = (req, next) => {
    const analytics = inject(AnalyticsService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // Only track errors for our API (skip identity, 3rd party, etc.)
            if (req.url.startsWith(environment.apiUrl)) {
                analytics.trackError(AnalyticsEvents.api_error, {
                    endpoint: normalizeAnalyticsEndpoint(req.url),
                    status_code: error.status,
                    error_type: error.name,
                    message: error.status === 0 ? 'Network request failed' : `HTTP ${error.status}`
                });
            }
            return throwError(() => error);
        })
    );
};
